// System Settings Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Fetch Customer from backend ***** //
export const fetchSystemSettings = async ({ commit }) => {
  try {
    const result = await Axios.get(`system_settings_show/1`)
    const data = result.data.data
    localStorage.systemCurrency = data.system_currency
    commit('setSystemSettings', data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Update SystemSetting  info ***** //
export const updateSystemSettingInfo = async (ignored, payload = null) => {
  try {
    payload.append('_method', 'PATCH')
    await Axios.post(`system_settings_update/1`, payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Fetch Customer from backend ***** //
export const oldFetchSystemSettings = async ({ commit }) => {
  try {
    const result = await Axios.get(`system_settings_show/1`)
    const data = result.data.data
    localStorage.systemCurrency = data.system_currency
    commit('setSystemSettings', data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
